import { createApp } from 'vue'

import i18n from './i18n'
import router from './router.ts'
import App from './App.vue'
import store from './store/store'
import filters from './vue-filters.js'
import { hasDeviceQueryHint } from './shared/deviceQuery'
import { applyTestFleetQuery } from './shared/testFleet'

import './assets/css/tailwind.css'
import './assets/scss/style.scss'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title

  if (to.query.webview === 'true') {
    store.dispatch('users/setIsWebView', true)
  }

  // Sticky like the webview flag above: the device hint is dropped from the URL
  // as soon as the deep link is forwarded to /subscription/:deviceId.
  if (hasDeviceQueryHint(to.query)) {
    store.dispatch('users/setHasDeviceQuery', true)
  }

  if (to.query.app) {
    store.dispatch('appcompat/setNativeApp', to.query.app)
  }

  applyTestFleetQuery(to.query['test-fleet'])

  next()
})

router.afterEach((to, from) => {
  localStorage.setItem('lastVisitedRoute', from.name)
})

const app = createApp(App)

app.config.globalProperties.$filters = filters

app.use(i18n)
app.use(router)
app.use(store)

app.mount('#app')
